<template>
  <div>
    <div v-if="userNonsmoking">
      <h2 class="form__title">Уважаемый посетитель!</h2>
      <p class="form__description form__description_align-center" v-if="$store.state.userNonsmoking">
        Данный сайт предназначен только для совершеннолетних потребителей табачной продукции
      </p>
    </div>
    <div v-else-if="docsNotConfirmed">
      <h2 class="form__title">Ваш паспорт не подтверждён</h2>
    </div>
    <div v-else>
      <h2 class="form__title">Сайт недоступен
      </h2>
      <p class="form__description form__description_no-vertical-margins form__description_align-center-all">
        К сожалению, доступ для вашей учетной записи ограничен
      </p>
    </div>

    <!--div class="form-row form-row_mobile-wrap form-row_align-center">
      <div class="form__nav">
        <router-link :to="{ name: 'feedback' }" class="form__link">Написать нам</router-link>
      </div>
    </div-->
  </div>
</template>

<script>
export default {
  name: "SignUpStepFail",
  computed: {
    userNonsmoking() {
      return this.$store.state.userNonsmoking
    },
    docsNotConfirmed() {
      return typeof this.$store.state.currentUser.segments.DocumentsModerationFail !== 'undefined'
    }
  }
}
</script>
